import { StepperOptions } from '@mydocma/import-export/lib/stepper/stepper.options';

export const importStepperOptions: StepperOptions = {
  linear: false
};
